<ng-container [formGroup]="uriForm">
  <div class="bv-vault-uri-row">
    <bit-form-field disableMargin class="bv-vault-uri-row__uri">
      <bit-label>{{ uriLabel }}</bit-label>
      <input bitInput formControlName="uri" #uriInput placeholder="ex https://google.com" />
      <button
        type="button"
        bitIconButton="bwi-clone"
        bitSuffix
        [appCopyClick]="uriForm.controls.uri.value"
        [valueLabel]="'uri' | i18n"
        showToast
        [label]="'copyValue' | i18n"
        [disabled]="!uriForm.controls.uri.value"
        data-testid="copy-uri-button"
      ></button>
    </bit-form-field>

    <bit-form-field disableMargin class="bv-vault-uri-row__match">
      <bit-label>{{ "matchDetection" | i18n }}</bit-label>
      <bit-select formControlName="matchDetection" #matchDetectionSelect>
        @for (o of uriMatchOptions; track o.value) {
          <bit-option [label]="o.label" [value]="o.value" [disabled]="o.disabled"></bit-option>
        }
      </bit-select>
    </bit-form-field>

    @if (canRemove) {
      <button
        type="button"
        bitIconButton="bwi-minus-circle"
        buttonType="dangerGhost"
        class="bv-vault-uri-row__remove"
        [label]="'deleteWebsite' | i18n"
        (click)="removeUri()"
        data-testid="remove-uri-button"
      ></button>
    }

    @if (canReorder) {
      <button
        role="application"
        type="button"
        bitIconButton="bwi-drag-and-drop"
        class="bv-vault-uri-row__reorder"
        cdkDragHandle
        [label]="'reorderToggleButton' | i18n: uriLabel"
        (keydown)="handleKeydown($event)"
        data-testid="reorder-toggle-button"
      ></button>
    }
  </div>

  @if (getMatchHints(); as hints) {
    <bit-hint class="bv-vault-uri-row__hint">
      {{ hints[0] | i18n }}
      @if (hints.length > 1) {
        <b>{{ "warningCapitalized" | i18n }}:</b>
        {{ hints[1] | i18n }}
      }
    </bit-hint>
  }
</ng-container>
